import { render } from "./OfferDescription.vue?vue&type=template&id=e999552e"
import script from "./OfferDescription.vue?vue&type=script&lang=js"
export * from "./OfferDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__